import { useState, useEffect } from 'react';
import * as anchor from '@project-serum/anchor';
import { Connection, PublicKey, clusterApiUrl } from '@solana/web3.js';
import idl from '../components/ABI/kingdomofants.json'; // Adjust the path as necessary
import useSolanaWeb3 from '../hooks/useSolanaWeb3'; // Updated for Solana
import { fetchNFTsOnchain } from '../apis';

const programID = new PublicKey(idl.metadata.address);
const network = clusterApiUrl('devnet');
const opts = { preflightCommitment: 'processed' };

function useNftDetails(activeTokenAddress, option) {
  const { wallet, connected, fectchANTStateData } = useSolanaWeb3();
  const [level, setLevel] = useState(null);
  const [remainPotions, setRemainPotions] = useState(0);
  const [nftImages, setNftImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  // Fetch NFT images only when the component mounts or when the wallet connection status changes
  useEffect(() => {
    const fetchNFTs = async () => {
      if (!wallet.connected) return;
      setIsLoading(true);
      try {
        // const response = await fetch('https://backend.kingdomofants.app/api/fetch-nfts', {
        const nfts = await fetchNFTsOnchain(wallet.publicKey.toString(), 0)
        if(option==="leveling") {
          let images = [];
          for (const nft of nfts) {
            const nftData = await fectchANTStateData(nft.mint);
            if (nftData && !nftData.boolLeveled) {
              images.push({
                id: nft.mint,
                imageUrl: nft.metadata.image,
              });
            }
          }
          setNftImages(images);
        } else if (option === "unleveling"){
          let images = [];
          for (const nft of nfts) {
            const nftData = await fectchANTStateData(nft.mint);
            if (nftData && nftData.boolLeveled) {
              images.push({
                id: nft.mint,
                imageUrl: nft.metadata.image,
              });
            }
          }
          setNftImages(images);
        } else {
          const images = nfts.map(nft => ({
            id: nft.mint,
            imageUrl: nft.metadata.image,
          }));
          setNftImages(images);
        }
       

      } catch (error) {
        console.error('Failed to fetch NFTs:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNFTs();
  }, [wallet.connected, wallet.publicKey]);

  // Fetch level and remaining potions whenever the activeTokenAddress changes
  useEffect(() => {
    const getNFTLevel = async () => {
      if (!activeTokenAddress) return; // Return early if there's no active token address

      const connection = new Connection(network, opts.preflightCommitment);
      const provider = new anchor.AnchorProvider(connection, wallet, opts.preflightCommitment);
      const program = new anchor.Program(idl, programID, provider);

      try {
        const [basicAntInfoAccount] = await anchor.web3.PublicKey.findProgramAddress(
          [Buffer.from(process.env.REACT_APP_ANT_STATE_SEED), wallet.publicKey.toBuffer(), new PublicKey(activeTokenAddress).toBuffer()],
          programID
        );

        const basicAntInfoAccountContent = await program.account.antState.fetch(basicAntInfoAccount);
        console.log('Fetched account content:', basicAntInfoAccountContent);
        setLevel(basicAntInfoAccountContent.level);
        setRemainPotions(basicAntInfoAccountContent.remainPotions);
      } catch (error) {
        console.error('Failed to fetch NFT level and remaining potions:', error);
      }
    };

    getNFTLevel();
  }, [activeTokenAddress, wallet, programID, network]);

  return { level, remainPotions, nftImages, isLoading };
}

export default useNftDetails;